import React, {useEffect} from 'react';
import {store} from 'store';

const reader = new FileReader();
reader.onload = onLoad;

export function ImageUploader({ onComplete, ...props }) {
  useEffect(() => {
    reader.onComplete = onComplete;
  }, [ onComplete ]);
  return (
    <input type="file" onChange={upload} {...props} />
  );
}

function upload({ target }) {
  reader.initiator = target;
  reader.initiator.parentNode.dataset.status = 'uploading';
  try {
    const [ file ] = target.files;
    if (!file) {
      throw 'No file selected.';
    } else if (!/png|jpe?g/.test(file.type)) {
      throw 'Selected file is not an image.';
    } else if (file.size > 5*1024*1024) {
      throw 'Selected file\'s size is over the limit (5MB).';
    }
    reader.readAsDataURL(file);
  } catch (errorMessage) {
    store.dispatch({
      type: 'UI_ERROR',
      errorMessage,
    });
    reader.initiator.parentNode.dataset.status = '';
  }
}

function onLoad() {
  this.onComplete({
    modelId: this.initiator.dataset.id,
    modelType: this.initiator.dataset.type,
    contentPlain: this.result,
    justUploaded: true,
  });
  this.initiator.parentNode.dataset.status = '';
  delete this.initiator;
}
